import React from "react";
import {
    Box,
    Modal,
    Typography,
    Grid,
    TextField,
    Button,
} from "@mui/material";

const StudentDetailModal = ({
    open,
    onClose,
    student,
    editData,
    onChange,
    onSave,
    onFileChange,
    onUploadImage,
}) => {
    if (!student) return null;

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    bgcolor: "#1A1A2E",
                    border: "2px solid #000",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    color: "#EFFFFD",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <Typography variant="h5" mb={2}>
                    Student Details
                </Typography>

                <Grid container spacing={2}>
                    {/* Student Info */}
                    <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Student Info
                        </Typography>
                        {[
                            "StudentIDNumber",
                            "FirstName",
                            "MI",
                            "LastName",
                            "BirthDate",
                            "Grade",
                            "StudentEmail",
                        ].map((field) => (
                            <TextField
                                key={field}
                                fullWidth
                                label={field.replace(/([A-Z])/g, " $1")}
                                name={field}
                                type={field === "BirthDate" ? "date" : "text"}
                                value={
                                    field === "BirthDate" && editData[field]
                                        ? new Date(editData[field]).toISOString().slice(0, 10)
                                        : editData[field] || ""
                                }
                                onChange={onChange}
                                margin="dense"
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    sx: { color: "#EFFFFD" },
                                }}
                            />
                        ))}
                    </Grid>

                    {/* Address */}
                    <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Address
                        </Typography>
                        {["Address", "City", "State", "Zip", "Phone"].map((field) => (
                            <TextField
                                key={field}
                                fullWidth
                                label={field}
                                name={field}
                                value={editData[field] || ""}
                                onChange={onChange}
                                margin="dense"
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    sx: { color: "#EFFFFD" },
                                }}
                            />
                        ))}
                    </Grid>

                    {/* Guardian */}
                    <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Guardian Info
                        </Typography>
                        {[
                            "guardian_FName",
                            "guardian_LName",
                            "guardian_Address",
                            "guardian_Apt",
                            "guardian_City",
                            "guardian_State",
                            "guardian_Zip",
                            "guardian_Phone",
                            "guardian_Email",
                        ].map((field) => (
                            <TextField
                                key={field}
                                fullWidth
                                label={field.replace(/_/g, " ")}
                                name={field}
                                value={editData[field] || ""}
                                onChange={onChange}
                                margin="dense"
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    sx: { color: "#EFFFFD" },
                                }}
                            />
                        ))}
                    </Grid>
                </Grid>

                {/* Image preview */}
                {editData.ImageURL && (
                    <Box mt={2}>
                        <img
                            src={editData.ImageURL}
                            alt="Student"
                            style={{
                                width: 150,
                                height: 150,
                                objectFit: "cover",
                                borderRadius: 8,
                            }}
                        />
                    </Box>
                )}

                {/* Upload */}
                <Box mt={2}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Upload or Update Student Image
                    </Typography>
                    <input
                        type="file"
                        onChange={onFileChange}
                        style={{ marginTop: 8, display: "block" }}
                    />
                    <Button
                        variant="contained"
                        onClick={onUploadImage}
                        sx={{ backgroundColor: "#84BD00", color: "#121212", mt: 1 }}
                    >
                        Upload Image
                    </Button>
                </Box>

                {/* Actions */}
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        onClick={onSave}
                        sx={{ backgroundColor: "#84BD00", color: "#121212", mr: 2 }}
                    >
                        Save
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{ backgroundColor: "#84BD00", color: "#121212" }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default StudentDetailModal;
